import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import styles from './index.css';

let initZoom = 1;

class Map extends PureComponent {
    static propTypes = {
        data: PropTypes.object,
        devicetype: PropTypes.string,
    };

    state = {
        type: 0,
    };

    echarts = null;
    map = null;
    worldArea = {};
    nameMap = {};

    async componentDidMount() {
        // 引入 ECharts 主模块
        this.echarts = await import('echarts/lib/echarts');

        // 引入世界地图
        await import('echarts/map/js/world');
        // 引入提示框和标题组件
        await import('echarts/lib/component/tooltip');

        this.worldArea = await import('../../../data/worldMap/worldArea');
        this.nameMap = await import('../../../data/worldMap/worldMap.json');

        this.nameMap = this.nameMap.default;

        this.mapRender(1);
    }

    mapRender = async (zoom, roam) => {
        const { type } = this.state;
        const {
            data: { all, list },
        } = this.props;

        if (this.map) {
            this.map.dispose();
        }

        this.map = this.echarts.init(document.getElementById('world'));

        let worldMap = await import('./world');

        worldMap = worldMap.default;

        this.echarts.registerMap('world', worldMap);

        let mapData = [];

        const yd = [...all, ...list].map(item => {
            const quezhen = isNaN(Number(item.quezhen)) ? 0 : Number(item.quezhen);
            const zhiyu = isNaN(Number(item.zhiyu)) ? 0 : Number(item.zhiyu);
            const siwang = isNaN(Number(item.siwang)) ? 0 : Number(item.siwang);
            const num = quezhen - zhiyu - siwang;

            return {
                name: item.name1 === '全国' ? '中国' : item.name2,
                num,
                quezhen,
                zhiyu,
                siwang,
            };
        });

        mapData = yd.map(item => ({
            name: item.name,
            itemStyle: {
                normal: {
                    areaColor: this.getWorldColor(type === 0 ? item.num : item.quezhen),
                    borderColor:
                        item.name === '中国' ? this.getWorldColor(type === 0 ? item.num : item.quezhen) : '#ffffff', // 边框颜色
                    borderWidth: item.name === 0.5, // 边框线宽
                },
            },
            num: [item.quezhen - item.zhiyu - item.siwang, item.quezhen, item.zhiyu, item.siwang],
        }));

        const worldSeries = [
            {
                name: '世界',
                type: 'map',
                mapType: 'world',
                roam,
                zoom,
                scaleLimit: {
                    max: 5,
                    min: 1,
                },
                left: 0,
                right: 0,
                top: 20,
                itemStyle: {
                    normal: {
                        borderColor: '#ffffff', // 边框颜色
                        borderWidth: 0.5, // 边框线宽
                    },
                },
                label: {
                    show: false,
                },
                data: mapData,
                nameMap: this.nameMap,
            },
        ];

        const option = {
            tooltip: {
                trigger: 'item',
                showDelay: 0,
                enterable: true,
                transitionDuration: 0.2,
                padding: 7,
                borderWidth: 1,
                extraCssText: 'background:rgba(0,0,0,0.6);box-shadow: 0px 0px 4px 0px rgba(219,219,219,0.5);',
                textStyle: {
                    color: '#FFFFFF',
                    fontFamily: 'PingFang-SC-Medium,PingFang-SC;',
                    fontSize: 12,
                    padding: 5,
                },
                formatter: params => {
                    if (params.data) {
                        let result = `<div>${params.name}${params.name === '中国' ? '（数据含港澳台）' : ''}</div>`;

                        params.data.num.forEach((item, index) => {
                            let color = '';
                            let text = '';

                            if (index === 0) {
                                color = '#455fce';
                                text = '现存确诊';
                            } else if (index === 1) {
                                color = '#e10000';
                                text = '累计确诊';
                            } else if (index === 2) {
                                color = '#28B7A3';
                                text = '累计治愈';
                            } else if (index === 3) {
                                color = '#8C8C8C';
                                text = '累计死亡';
                            }

                            result += `<div style="margin-top: 1px"><span style="display:inline-block;margin: 0 5px 3px 0;border-radius:50%;width:5px;height:5px;font-family: PingFangSC-Regular, PingFang SC;background-color:${color}"></span>${text}: ${item ||
                                0}</div>`;
                        });

                        if (Object.keys(this.worldArea).indexOf(params.name) > -1 && this.worldArea[params.name].code) {
                            result += `<div style="margin-top: 1px"><a style="color: #ffffff" href=${this.getInfoUrl(
                                params.name,
                            )}>进入详情 >></a></div>`;
                        } else if (params.name === '中国') {
                            result += `<div style="margin-top: 1px"><a style="color: #ffffff" href=${this.getChinaUrl()}>进入详情 >></a></div>`;
                        }

                        return result;
                    }

                    return '';
                },
            },
            series: worldSeries,
        };

        this.map.setOption(option);
    };

    getInfoUrl = areaName => {
        const { devicetype } = this.props;

        let url = '';
        let code = '';

        Object.keys(this.worldArea).every(item => {
            if (areaName === item) {
                code = this.worldArea[item].code;

                return false;
            }

            return true;
        });

        if (devicetype === 'share') {
            url = `https://ishare.ifeng.com/c/s/7uLyp1412jw?code=${code}&needpage=1&webkit=1`;
        } else if (devicetype === 'client') {
            url = `https://news.ifeng.com/c/specialClient/7uLyp1412jw?code=${code}&needpage=1&webkit=1`;
        } else {
            url = `https://news.ifeng.com/c/special/7uLyp1412jw?code=${code}&needpage=1&webkit=1`;
        }

        if (window.location.href.indexOf('srctag') > -1) {
            url = `https://news.ifeng.com/c/vivo/7uLyp1412jw?code=${code}`;
        }

        return url;
    };

    getChinaUrl = () => {
        const { devicetype } = this.props;

        let url = '';

        if (devicetype === 'share') {
            url = 'https://ishare.ifeng.com/c/s/7tPlDSzDgVk?needpage=1&webkit=1';
        } else if (devicetype === 'client') {
            url = 'https://news.ifeng.com/c/specialClient/7tPlDSzDgVk?needpage=1&webkit=1';
        } else {
            url = 'https://news.ifeng.com/c/special/7tPlDSzDgVk?needpage=1&webkit=1';
        }

        if (window.location.href.indexOf('srctag') > -1) {
            url = 'https://news.ifeng.com/c/vivo/7tPlDSzDgVk';
        }

        return url;
    };

    getWorldColor = num => {
        let color = '#F2DADB';

        if (num > 9999999) {
            color = '#420C0C';
        } else if (num > 4999999) {
            color = '#6C0000';
        } else if (num > 999999) {
            color = '#9E0707';
        } else if (num > 499999) {
            color = '#BF5A53';
        } else if (num > 9999) {
            color = '#CE8A86';
        } else if (num === 0) {
            color = '#ffffff';
        }

        return color;
    };

    handleZoomIn = () => {
        if (initZoom === 5) {
            return;
        }

        initZoom++;

        this.mapRender(initZoom, true);
    };

    handleZoomOut = () => {
        if (initZoom === 1) {
            return;
        }

        initZoom--;

        this.mapRender(initZoom, initZoom > 1);
    };

    handleReset = () => {
        initZoom = 1;

        this.mapRender(initZoom);
    };

    handleTypeChange = type => {
        this.setState(
            {
                type,
            },
            () => {
                this.mapRender(1, false, type);
            },
        );
    };

    render() {
        const { type } = this.state;

        return (
            <Fragment>
                <div className={styles.box}>
                    <div id="world" className={styles.map} />
                    <span className={styles.tip} />
                    <div className={styles.toolbox}>
                        <a onClick={this.handleZoomIn}>
                            <span>+</span>
                        </a>
                        <a onClick={this.handleZoomOut}>
                            <span>-</span>
                        </a>
                        <a onClick={this.handleReset}>
                            <span>重置</span>
                        </a>
                    </div>
                </div>
                <div className={styles.btn_box}>
                    <div
                        className={type === 0 ? styles.current_item : styles.item}
                        onClick={() => this.handleTypeChange(0)}>
                        <span>现存确诊</span>
                    </div>
                    <div
                        className={type === 1 ? styles.current_item : styles.item}
                        onClick={() => this.handleTypeChange(1)}>
                        <span>累计确诊</span>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default errorBoundary(Map);
